module.exports = __webpack_public_path__ + "img/Pessoas.667a01e9.jpg";